import { ModalLikeContainer } from "../modal/modal-style";
import { styled } from "sharedUI/styles";

export const ModalContainer = styled(ModalLikeContainer)`
    width: 460px;
    height: 372px;
    border-radius: 12px;

    padding: 24px;
`;

export const HeaderContainer = styled.div`
    display: flex;
    align-items: left;
    font-size: 18px;
    line-height: 32px;
    min-height: 32px;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    color: ${p => p.theme.fgColorDark};

    span {
        margin-left: 12px;
    }
    em {
        font-weight: bold;
        font-style: normal;
    }
`;

export const SelectionContainer = styled.div`
    padding-top: 24px;
    padding-bottom: 24px;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
`;

export const SelectionOption = styled.input`
    appearance: none;

    height: 152px;
    width: 152px;
    box-sizing: border-box;
    margin-bottom: 12px;
    grid-area: "button";
    border-radius: 8px;

    :checked {
        background: ${p => p.theme.borderColorLight};
    }

    :hover {
        border: 2px solid ${p => p.theme.borderColorLight};
    }
`;

export const SelectionIcon = styled.img`
    position: absolute;
    top: 0px;
    left: 0px;
    width: 152px;
    height: 152px;
    margin-left: 6px;
    padding: 25%;

    pointer-events: none;
`;

export const SelectionFieldset = styled.fieldset`
    border: none;
    display: inline;
`;

export const SelectionByline = styled.label<{ selected?: boolean }>`
    font-size: 13px;
    line-height: 17px;
    text-align: center;
    grid-area: "byline";

    color: ${p => (p.selected ? p.theme.fgColorDark : p.theme.fgColorMedium)};
`;

// Ugh... fieldsets are non-cooperative with grid divs.
export const OptionContainerWrapper = styled.div`
    display: inline-block;
`;

// transform: translateZ(0px) tricks child position: absolute into positioning
// relative to this container. This is as per the CSS3 standard.
export const SelectionOptionContainer = styled.div`
    padding-left: 6px;
    padding-right: 6px;
    display: grid;
    grid-template-areas:
        "button"
        "byline";
    transform: translateZ(0px);
`;

export const ConfirmationContainer = styled.div`
    height: 32px;
    min-height: 32px;
    p {
        line-height: 32px;
    }
`;

export const ButtonRow = styled.div`
    display: flex;
    justify-content: flex-end;
    align-content: stretch;
    > :first-child {
        margin-right: 8px;
    }
`;
